import { Outlet } from "react-router-dom";

import NavbarItems from "~/components/shared/NavbarItems.jsx";

import { userNavbarItems } from "../../constants";
import styles from "./user-layout.module.css";

const UserLayout = () => {
  return (
    <>
      <div className={styles.sidebar}>
        <NavbarItems sidebaritems={userNavbarItems} type="user" />
      </div>
      <div className={styles.content}>
        <Outlet />
      </div>
    </>
  );
};

export default UserLayout;
